
interface OAuth2 {
    access_token: string;
    expires_in: number;
    scope: string;
    refresh_token: string;
}

export interface Profile {
    customerId: number;
    userId: number;
    status: string;
    userAccount: string;
    fullName: string;
    firstName: string;
    lastName: string;
    phoneNumber: number;
    userType: string;
}

export interface Role {
    roleCode: string;
    roleName: string;
    roleDesc: string;
    roleType: string;
}

export interface Application {
    applicationId: number;
    applicationName: string;
    applicationCode: string;
    roles: Array<Role>;

}

interface IntegrationCustomer {
    customerId: number;
    customerDesc: string;
    customerCode: number;
    userId: number;
}

export interface UserInfo {
    oauth2: OAuth2;
    jwt: string;
    powerUser: string;
    edit: string;
    customerId: number;
    sessionId: number;
    role: string;
    country: string;
    applications: Array<Application>;
    profile: Profile;
    customer: IntegrationCustomer;
}
